import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background-50 px-6">
          <div className="max-w-md text-center">
            <div className="mx-auto w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
              <i className="ri-error-warning-line text-2xl" />
            </div>
            <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">页面出现异常</h1>
            <p className="mt-2 text-sm text-foreground-600">{this.state.error.message}</p>
            <button
              type="button"
              onClick={() => {
                this.setState({ error: null });
                window.location.assign('/sites');
              }}
              className="mt-5 px-4 py-2.5 text-sm font-semibold text-background-50 bg-accent-500 rounded-md"
            >
              返回网站列表
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
